export default "__VITE_ASSET__BF$db9ju__"